import { Select } from 'antd';
import css from './index.module.scss';
import IotComp from './IotComp';
import DirectConnection from './DirectConnection';
import Bluetooth from './Bluetooth';
import { useGlobal } from '@/utils/useGlobal';
import { EFArrowRightDown } from '@/components/UI/svg/appDownload';

const { Option } = Select;

export default function QuickGuide() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('app');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const [activeRight, setActiveRight] = useState(0);
    const isShowEn = ['us', 'au', 'ph', 'eu', 'ca', 'uk', 'za', 'cis', 'br', 'mx', 'nl'].includes(locale);

    const categoryTree = [
        { title: t('quickGuideChild.tree1'), value: '0' },
        { title: t('quickGuideChild.tree2'), value: '1' },
        {
            title: t('quickGuideChild.tree3'),
            value: '2',
            children: [
                {
                    title: t('quickGuideChild.tree3-iot'),
                    value: '3',
                    desc1: t('quickGuideChild.iot-model1'),
                    desc2: t('quickGuideChild.iot-model2'),
                    step: [
                        {
                            title: t('quickGuideChild.iot-step1'),
                            img: isShowEn ? '/img/appDownload/pc/iot/1.png' : `/img/appDownload/pc/iot/1-${locale}.png`,
                        },
                        {
                            title: t('quickGuideChild.iot-step2'),
                            img: isShowEn ? '/img/appDownload/pc/iot/2.png' : `/img/appDownload/pc/iot/2-${locale}.png`,
                        },
                        {
                            title: t('quickGuideChild.iot-step3'),
                            img: isShowEn ? '/img/appDownload/pc/iot/3.png' : `/img/appDownload/pc/iot/3-${locale}.png`,
                        },
                    ],
                    note: t('quickGuideChild.note1'),
                },
                {
                    title: t('quickGuideChild.tree3-direct'),
                    value: '4',
                    desc1: t('quickGuideChild.direct-model1'),
                    desc2: t('quickGuideChild.direct-model2'),
                    step: [
                        {
                            title: t('quickGuideChild.direct-step1'),
                            img: isShowEn ? '/img/appDownload/pc/connection/1.png' : `/img/appDownload/pc/connection/1-${locale}.png`,
                        },
                        {
                            title: t('quickGuideChild.direct-step2'),
                            img: isShowEn ? '/img/appDownload/pc/connection/2.png' : `/img/appDownload/pc/connection/2-${locale}.png`,
                        },
                        {
                            title: t('quickGuideChild.direct-step3'),
                            img: isShowEn ? '/img/appDownload/pc/connection/3.png' : `/img/appDownload/pc/connection/3-${locale}.png`,
                        },
                        {
                            title: t('quickGuideChild.direct-step4'),
                            img: isShowEn ? '/img/appDownload/pc/connection/4.png' : `/img/appDownload/pc/connection/4-${locale}.png`,
                        },
                    ],
                    note: t('quickGuideChild.note2'),
                },
                {
                    title: t('quickGuideChild.tree3-bluetooth'),
                    value: '5',
                    desc1: t('quickGuideChild.bluetooth-model1'),
                    desc2: t('quickGuideChild.bluetooth-model2'),
                    step: [
                        {
                            title: t('quickGuideChild.bluetooth-step1'),
                            img: isShowEn ? '/img/appDownload/pc/bluetooth/1.png' : `/img/appDownload/pc/bluetooth/1-${locale}.png`,
                        },
                        {
                            title: t('quickGuideChild.bluetooth-step2'),
                            img: isShowEn ? '/img/appDownload/pc/bluetooth/2.png' : `/img/appDownload/pc/bluetooth/2-${locale}.png`,
                        },
                        {
                            title: t('quickGuideChild.bluetooth-step3'),
                            img: isShowEn ? '/img/appDownload/pc/bluetooth/3.png' : `/img/appDownload/pc/bluetooth/3-${locale}.png`,
                        },
                    ],
                    note: t('quickGuideChild.note3'),
                },
            ],
        },
    ];

    return (
        <div className={css.quickGuide}>
            <div className="quick-guide">
                <div className="select_box">
                    <Select value={active} suffixIcon={<EFArrowRightDown className="icon" />} onChange={(val) => setActive(Number(val))}>
                        {categoryTree.map((item: any, index: number) => (
                            <Option value={index} key={index}>
                                {item.title}
                            </Option>
                        ))}
                    </Select>
                    {categoryTree[active].children ? (
                        <Select value={activeRight} suffixIcon={<EFArrowRightDown className="icon" />} onChange={(val) => setActiveRight(Number(val))}>
                            {categoryTree[active].children?.map((childItem: any, childIndex: number) => (
                                <Option value={childIndex} key={childIndex}>
                                    {childItem.title}
                                </Option>
                            ))}
                        </Select>
                    ) : (
                        ''
                    )}
                </div>
                <div className="content-box">
                    <div className="child-box">
                        {active === 0 && <IotComp />}
                        {active === 1 && <DirectConnection />}
                        {active === 2 && <Bluetooth data={(categoryTree[active].children as any)[activeRight]} />}
                    </div>
                </div>
            </div>
        </div>
    );
}
